import { v4 } from 'uuid';

import { Module, TOC } from '../model/types';

export const generateModuleTOC = (data: Module): TOC[] => {
  if (data.modules?.length) {
    return data.modules.map(
      (m) =>
        ({
          id: m.id || v4(),
          type: 'lesson',
          title: m.title,
          sections: generateModuleTOC(m).flatMap((s) => ({
            id: s.id || v4(),
            type: s.type,
            title: s.title,
            sections: [],
          })),
        }) as TOC,
    );
  }

  const lessons = data.syllabus.map((l) => ({
    id: l.id || v4(),
    title: l.title,
    type: 'lesson',
    order: l.order,
    sections: l.sections.map((s) => s.title),
  }));

  const quizzes = data.quizzes.map((q) => ({
    id: q.id || v4(),
    title: q.title,
    type: 'quiz',
    order: q.order,
    sections: [],
  }));

  const videos = data.videos.map((q) => ({
    id: q.id || v4(),
    title: q.title,
    type: 'video',
    order: q.order,
    sections: [],
  }));

  const combined = [...lessons, ...quizzes, ...videos];

  combined.sort((a, b) => a.order - b.order);

  return combined.map(
    ({ id, type, title, sections }) =>
      ({
        id,
        type,
        title,
        sections,
      }) as TOC,
  );
};
